//import CryptoJS from "crypto-js";

export const Signer = {
  // sign: function(key, nonce, message) {
  //   var hmac = CryptoJS.HmacSHA256(nonce + message, CryptoJS.enc.Base64.parse(key));
  //   var digest = CryptoJS.enc.Base64.stringify(hmac);
  //   return digest;
  // },
  digest: async (key,nonce,message) => {
    const encoder = new TextEncoder();
    let algorithm = { name: "HMAC", hash: "SHA-256" };
    let newKey = await crypto.subtle.importKey("raw", encoder.encode(key), algorithm, true, ["sign", "verify"]);
    let signature = await crypto.subtle.sign(algorithm.name, newKey, encoder.encode(nonce + message));
    let digest = btoa(String.fromCharCode(...new Uint8Array(signature)));
    return digest;
  },

  nonce: function () {
    return new Date().getTime();
  },
  
}